import { render, staticRenderFns } from "./SalonDashboard.vue?vue&type=template&id=4c1081bc"
import script from "./SalonDashboard.vue?vue&type=script&lang=js"
export * from "./SalonDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports